export interface activityIdMapType {
    [key: string]: number;
}

export const activityIdMap: activityIdMapType = {
    us: 70,
    ca: 71,
};
